module.exports = __webpack_public_path__ + "static/media/img-3.6318df05.jpg";